import script from "./PendingMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingMessage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import Avatar from "@/components/Avatar.vue";
import CardMeta from "@/components/CardMeta.vue";
script.components = Object.assign({}, { Avatar, CardMeta }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { Avatar, CardMeta }, script.__o.components);}